import Paper from "@mui/material/Paper";
import PaymentInstallment from "components/PaymentInstallment/PaymentInstallment";
import { convertUTCToLocalDate } from "components/UTC/UtcConverter";
import * as calculation from "helper/CalculateEvent";
import { formatDate } from "helper/dateFormat";
import { numberFormat } from "helper/numberFormat";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { eventsSlice, setTicketTypeVariants } from "services/api/events";
import { DataFoundWrapper, Discount, PayDetails, PaymentAmount, SummaryItem, SummaryItemCharge, SummaryItemInfo, SummaryItemLedger, SummaryTitle, TotalDueAmount, TotalPayment, Wrapper } from "./Theme";

export const SummaryCard = ({ 
	handleTotalForPay, 
	totalPaymentWithCVFee, 
	billMyAccount,
	newProducts,
	setProducts,
	dueAmountCF,
	totalDueAmountWithCF,
	totalDiscount,
	dueAmountTotalDiscount,
	totalDueAmount,
	isInstallmentEnabled,
	setActivePaymentAfter
}) => {
	const { products, formOnlineData, varients, numberOfTickets, totalProducts,ticketTypeVariants } = useSelector((state) => state?.Events);
	const { eventData } = useSelector((state) => state?.Events);
	const totalPay = handleTotalForPay();

	const dispatch = useDispatch();

	useEffect(() => {
		// Process the input data and update the products state
		const processedData = processInputData(varients);
		const totalAmount = processedData?.reduce((sum, obj) => sum + obj.amount, 0);
		const finalAmount = Number.isNaN(totalAmount) ? 0 : totalAmount;
		dispatch(eventsSlice.actions.setTotalProducts(finalAmount));
		setProducts(processedData);
	}, [dispatch, varients]);

	const processInputData = (data) => {
		const processedProducts =
			data && Object.values(data)?.length > 0
				? Object.values(data)?.map((item, index) => {
						if (item.variantsInfo && item.variantsInfo.length > 0) {
							const totalCounterSum = item.variantsInfo.reduce((sum, obj) => sum + obj.counterValue, 0);
							let totalAmount = 0;
							if (item.variantsInfo && item.variantsInfo.length > 0) {
								item.variantsInfo.forEach((variant) => {
									totalAmount += variant.counterValue * variant.amount;
								});
								return {
									title: item.varientTitle,
									total: totalCounterSum,
									amount: totalAmount,
									type: item.type,
									priceId: item.id,
								};
							}
						} else {
							if (item.type === "openAmount") {
								return {
									title: item.varientTitle,
									total: item.counterValue || 0,
									amount: item.price ? item.price * item.counterValue : 0,
									type: item.type,
									priceId: item.id,
								};
							} else {
								return {
									title: item.varientTitle,
									total: item.counterValue || 0,
									amount: item.amount * item.counterValue,
									type: item.type,
									priceId: item.id,
								};
							}
						}
				  })
				: [];
		return processedProducts;
	};

	const calculateInstallmentAmount = (item, type = "ticket") => {
		if(!item?.installmentStatus) return "";
		if (item?.installment?.value) {
			const itemAmount = type === "ticket" ? item?.amount * item?.selectedQuantity : item?.amount;
			return numberFormat({
				number: +itemAmount / item?.installment?.value,
				decimal: 2,
				style: "currency",
			});
		}
		return "";
	};


	const enabledTicketInstallment = () => {
		const currentPrice = eventData?.eventPricing?.prices?.find((price) => price?.type === "onRegistration");
		return currentPrice || {};
	}
	const enableProductInstallment = (item) => {
		const currentPrice = eventData?.eventPricing?.prices?.find((price) => price?._id === item?.priceId);
		return currentPrice || {};
	}


	return (
		<>
			{(totalPay?.total !== "0.00" || totalProducts > 0) && (
				<Paper
					sx={{
						minHeight: "278px",
						borderRadius: "10px",
						backgroundColor: (theme) => (theme.palette.mode === "dark" ? "#1A2027" : "#fff"),
					}}
				>
					<Wrapper>
						<SummaryTitle>
							<span>Summary</span>
						</SummaryTitle>
						<DataFoundWrapper>
							{(!eventData?.freeEvent && !!ticketTypeVariants?.length) && ticketTypeVariants?.map((item, index) => item?.selectedQuantity > 0 && (
									<SummaryItem>
										<SummaryItemCharge>
										<SummaryItemInfo>
											<SummaryItemLedger>{item?.selectedQuantity} {item?.name}</SummaryItemLedger>
										</SummaryItemInfo>
										<PaymentAmount>{`${numberFormat({number:(+item?.amount * +item?.selectedQuantity), decimal: 2, style: "currency"})}`}</PaymentAmount>
										</SummaryItemCharge>
										{(isInstallmentEnabled && item?.amount > 0 && enabledTicketInstallment()?.isInstallmentTransaction) && (
											<PaymentInstallment 
												onAllowInstallmentChange={(e) => {
													const {checked} = e.target;
													const updatedTicketTypeVariants = ticketTypeVariants?.map((val) => {
														if(val?.name === item?.name){
															return {
																...val, 
																installmentStatus: checked,
																...(!checked && {installment: null})
															}
														}
														return val;
													}
													);
													dispatch(setTicketTypeVariants(updatedTicketTypeVariants));
													setActivePaymentAfter();
												}}
												installmentValue={item?.installmentStatus || false}
												onSelectInstallment={(value) => {
													const updatedTicketTypeVariants = ticketTypeVariants?.map((val) => {
														if(val?.name === item?.name){
															return {
																...val, 
																installment: value
															}
														}
														return val;
													}
													);
													dispatch(setTicketTypeVariants(updatedTicketTypeVariants));
												}}
												selectedInstallment={item?.installment}
												installmentAmount={calculateInstallmentAmount(item, "ticket")}
												maxInstallment={enabledTicketInstallment()?.installmentDetailsTransaction?.numberOfInstallment}
											/>
										)}
									</SummaryItem>									
							))}
							{newProducts.map((product, index) => (
								<SummaryItem>
									{product?.total > 0 && product?.amount > 0 && (
										<>
										<SummaryItemCharge>
											<SummaryItemInfo>
												<SummaryItemLedger>
													{product?.total} {product?.title}
												</SummaryItemLedger>
											</SummaryItemInfo>
											{`${numberFormat({number:product?.amount, decimal: 2, style: "currency"})}`}
										</SummaryItemCharge>
										{(isInstallmentEnabled && enableProductInstallment(product)?.isInstallmentTransaction) && (
											<PaymentInstallment 
												onAllowInstallmentChange={(e) => {
													const {checked} = e.target;
													const updatedNewProducts = newProducts?.map((val) => {
														if(val?.title === product?.title){
															return {
																...val, 
																installmentStatus: checked,
																...(!checked && {installment: null})
															}
														}
														return val;
													}
													);
													setProducts(updatedNewProducts);
													setActivePaymentAfter();
												}}
												installmentValue={product?.installmentStatus || false}
												onSelectInstallment={(value) => {
													const updatedNewProducts = newProducts?.map((val) => {
														if(val?.title === product?.title){
															return {
																...val, 
																installment: value
															}
														}
														return val;
													}
													);
													setProducts(updatedNewProducts);
												}}
												selectedInstallment={product?.installment}
												installmentAmount={calculateInstallmentAmount(product, "product")}
												maxInstallment={enableProductInstallment(product)?.installmentDetailsTransaction?.numberOfInstallment}
											/>
										)}
									</>
									)}
								</SummaryItem>
							))}
							{totalDiscount > 0 && (
                <PayDetails>
									<li>
										Total discount
										<span>
											{numberFormat({number:+totalDiscount, decimal: 2, style: "currency"})}
										</span>
									</li>
								</PayDetails>
							)}
							{(dueAmountCF > 0 && !billMyAccount) && (
								<SummaryItem>
									<SummaryItemCharge>
										<div>
											<span style={{ color: "#002E5C", fontSize: "14px" }}>Convenience fee of due</span>
										</div>
										<PaymentAmount>{numberFormat({number:+dueAmountCF, decimal: 2, style: "currency"})}</PaymentAmount>
									</SummaryItemCharge>
								</SummaryItem>
							)}
							<TotalPayment>
								<p>Payment Total</p>
								<span>{numberFormat({number:+totalPaymentWithCVFee, decimal: 2, style: "currency"})}</span>
							</TotalPayment>
							<TotalDueAmount>
								<p>{dueAmountTotalDiscount > 0 ? "Due Now After Discount" : "Due Now"}</p>
								<span>{numberFormat({ number: billMyAccount ? totalDueAmount : totalDueAmountWithCF, decimal: 2, style: "currency" })}</span>
							</TotalDueAmount>
						</DataFoundWrapper>
					</Wrapper>
				</Paper>
			)}
		</>
	);
};
